var _path, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarRoomSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 55,
    fill: "none",
    viewBox: "0 0 54 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    d: "M11.375 0h31v2h-31z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 48,
    x: 13.375,
    y: 7,
    fill: "#D9D9D9",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.375,
    cy: 17,
    r: 4,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.375,
    cy: 31,
    r: 4,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.375,
    cy: 44,
    r: 4,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.375,
    cy: 17,
    r: 4,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.375,
    cy: 31,
    r: 4,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.375,
    cy: 44,
    r: 4,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarRoomSpace);
export default __webpack_public_path__ + "static/media/war-room-space.96c74dc62ac80a563e02b6a4f52b800d.svg";
export { ForwardRef as ReactComponent };